"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Button_1 = __importDefault(require("@mui/material/Button"));
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var formik_1 = require("formik");
var react_1 = require("react");
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var react_i18next_1 = require("react-i18next");
var PopIn_1 = __importDefault(require("../PopIn"));
function UploadFileField(_a) {
    var onChange = _a.onChange, name = _a.name, label = _a.label, types = _a.types, size = _a.size;
    var setFieldValue = (0, formik_1.useFormikContext)().setFieldValue;
    var _b = __read((0, react_1.useState)(undefined), 2), fileToUpload = _b[0], setFileToUpload = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), showError = _c[0], setShowError = _c[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var _d = __read((0, react_1.useState)([]), 2), errorMessages = _d[0], setErrorMessages = _d[1];
    var validation = function (file) {
        var valid = true;
        var errorMessagesToSet = [];
        if (types !== undefined) {
            if (!types.includes(file.type)) {
                valid = false;
                errorMessagesToSet.push("".concat(t('ds.uploadfilefield.error.type'), " ").concat(types.join()));
            }
        }
        if (size !== undefined) {
            if (!(file.size <= size * 1024 * 1024)) {
                valid = false;
                errorMessagesToSet.push("".concat(t('ds.uploadfilefield.error.size'), " ").concat(size, "MB"));
            }
        }
        setErrorMessages(errorMessagesToSet);
        setShowError(!valid);
        return valid;
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Stack_1.default, __assign({ direction: "row", alignItems: "center", spacing: 2 }, { children: [(0, jsx_runtime_1.jsxs)("label", __assign({ htmlFor: "upload-file" }, { children: [(0, jsx_runtime_1.jsx)("input", { style: { display: 'none' }, id: "upload-file", name: "upload-file", type: "file", onChange: function (event) {
                                    if (event.currentTarget.files !== null &&
                                        validation(event.currentTarget.files[0])) {
                                        setFileToUpload(event.currentTarget.files[0]);
                                        if (onChange !== undefined) {
                                            onChange(event);
                                        }
                                        else {
                                            setFieldValue(name, event.currentTarget.files[0]);
                                        }
                                    }
                                }, className: "form-control" }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ variant: "contained", component: "span" }, { children: label }))] })), fileToUpload && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, { children: fileToUpload.name }), (0, jsx_runtime_1.jsx)(Close_1.default, { sx: { color: 'redWarning.main', cursor: 'pointer' }, onClick: function () {
                                    setFileToUpload(undefined);
                                    setFieldValue(name, undefined);
                                } })] }))] })), showError && ((0, jsx_runtime_1.jsx)(PopIn_1.default, __assign({ title: t('ds.uploadfilefield.error.title'), onClose: function () {
                    setShowError(false);
                } }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, __assign({ p: 4, spacing: 1 }, { children: [errorMessages.map(function (errorMessage) {
                            return ((0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ variant: "body1", color: "redWarning.main" }, { children: errorMessage }), errorMessage));
                        }), (0, jsx_runtime_1.jsx)(Stack_1.default, __assign({ direction: "row", justifyContent: "flex-end", sx: { pt: 18 } }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ variant: "outlined", onClick: function () {
                                    setShowError(false);
                                } }, { children: t('ds.uploadfilefield.error.back') })) }))] })) })))] }));
}
exports.default = UploadFileField;
UploadFileField.defaultProps = {
    onChange: undefined,
    label: 'Upload',
    types: undefined,
    size: undefined,
};
//# sourceMappingURL=UploadFileField.js.map